import React, { Component } from 'react';
import Loader from "../../Loader";
import Very from "../../../helpers/request_wrapper";

class Regenerate extends React.Component {
    constructor(props) {
        super(props);
    }


    componentDidMount = () => {
        const { persona_id } = this.props;
        Very.post(`/personas/${persona_id}/regenerate`).then(res => {
            const persona = res.data;
            window.location.replace(`/personas/${persona.id}`)
        }, err => {
            console.log(err)
        })
    };

    render () {
        return (
            <React.Fragment>
              <Loader/>
            </React.Fragment>
        )
    }
}

export default Regenerate